import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import PremiumCalculator from "../PremiumCalculatorPublic";

const DEFAULT_CLOSE_COLOR = "#333333";

export default function FooterCalculatorDialog({
  open,
  onClose,
  primaryColor = DEFAULT_CLOSE_COLOR,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ "& .MuiPaper-root": { borderRadius: "20px", maxWidth: "90vw" } }}
    >
      <DialogContent>
        <PremiumCalculator />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            borderRadius: "12px",
            color: primaryColor,
            fontWeight: 600,
            "&:hover": { backgroundColor: "rgba(51, 51, 51, 0.08)" },
            textTransform: "none",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FooterCalculatorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
};
